/**
 * Hook to read a GrowthBook feature flag value with a fallback.
 * GrowthBook is injected via GTM onto window._growthbook.
 * If GrowthBook is not available or the flag is off/missing, the fallback is returned.
 */
export const useGrowthBookFeatureValue = (key, fallback) => {
    if (typeof window !== 'undefined' && window._growthbook) {
        return window._growthbook.getFeatureValue(key, fallback);
    }
    return fallback;
};